<template>
  <div class="category-collapsable-category-attachable-overview">
    <a-collapse>
      <a-collapse-panel v-for="category in categories" :key="category.id" :header="category.name" :force-render="true">
        <span v-if="category.attachable_count > 0" slot="extra">{{ category.attachable_count }}</span>
        <category-paginated-attachable-overview
            :ref="'overview' + category.id"
            :customer-id="customerId"
            :category="category.id"
            v-on:total-updated="onTotalUpdated">
        </category-paginated-attachable-overview>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import categoryApi from "~/api/category";
import attachableCategoryStore from "~/modules/attachable_category/store";
import {mapGetters} from "vuex";

export default {
  name: "CategoryCollapsableAttachableOverviewComponent",
  props: {
    categoryIds: {
      type: Array,
      required: false,
    },
    customerId: {
      type: [String, Number],
      required: true,
    },
  },
  components: {},
  data() {
    return {
      categories: [],
      categoryCounts: [],
    }
  },
  created() {
    const STORE_KEY = '$_attachable_category';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, attachableCategoryStore);
    }

    this.initCategories();
  },
  computed: {
    ...mapGetters({
      selectedAttachables: '$_attachable_category/selectedAttachables',
    }),
  },
  methods: {
    initCategories() {
      categoryApi.getCustomerCategories().then(response => {
        this.categories = response.data;
      });
    },
    onTotalUpdated(categoryId, count) {
      let category = this.categories.filter(category => {
        return category.id === categoryId;
      }).pop();

      if (category !== null) {
        let index = this.categories.indexOf(category);

        this.categories[index].attachable_count = count;
      }

      // this.categories.forEach(category => {
      //   if (
      //       category.id !== categoryId
      //       && typeof this.$refs['overview' + category.id] !== "undefined"
      //       && this.$refs['overview' + category.id].length > 0
      //   ) {
      //     this.$refs['overview' + category.id][0].reloadOnce()
      //   }
      // })
    },
  },
  mounted() {
  }
}
</script>

<style>
.category-collapsable-category-attachable-overview .ant-collapse-content-box {
  padding: 0;
}
</style>